import { Cookies } from 'react-cookie';

import { signVisitByPestEmployeeFormValues } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface signVisitByPestEmployeeInterface {
  signVisitByPestEmployee: signVisitByPestEmployeeFormValues;
  id: string;
  slug: string;
}

export const singVisitByPestEmployeePostDigest = async ({
  signVisitByPestEmployee,
  id,
  slug,
}: signVisitByPestEmployeeInterface) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.post(
    `/objects/${slug}/technician-digests/${id}/tech-signature/`,
    {
      ...signVisitByPestEmployee,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};
